import React, { Component } from "react";
import { Button, Upload, Icon, Popover, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { uploadFile } from "../../redux/actions/flight";
import { connect } from "react-redux";
import { deleteFile } from "../../redux/actions/setting";

class UploadFile extends Component {
  state = {
    fileList: [],
    isLoading: false,
  };

  componentDidMount () {
    // Initialize fileList from props on mount
    this.syncPropsToState(this.props);
  }

  componentDidUpdate (prevProps) {
    // Always sync with props when they change (modal reopen, fresh data, etc.)
    if (prevProps.fileList !== this.props.fileList) {
      this.syncPropsToState(this.props);
    }
  }

  syncPropsToState = (props) => {
    // Always use props data as the source of truth when available
    if (props.fileList && Array.isArray(props.fileList)) {
      this.setState({ fileList: [...props.fileList] });
    } else {
      // If no props fileList, initialize empty
      this.setState({ fileList: [] });
    }
  }

  handleUpload = ({ file, fileList }) => {
    const { id, type, multiple } = this.props;

    // File size validation
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
      return message.error(`File ${file.name} must smaller than 10MB!`);
    }

    // Set loading state
    this.setState({ isLoading: true });

    // Prepare upload parameters
    const param = {
      files: file,
      typeFile: type,
      id: id,
    };

    // Perform upload and handle response
    this.props.uploadFile(param)
      .then((res) => {
        if (res && res.payload && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
          const data = res.payload.data.data;

          if (data.listFiles && data.listFiles.length > 0) {
            // Successfully uploaded - add the new file with server response data
            const uploadedFile = data.listFiles[data.listFiles.length - 1];
            const newFile = {
              uid: Date.now() + Math.random(), // Generate unique ID
              name: file.name,
              status: "done",
              url: uploadedFile.linkFile,
              size: file.size,
              lastModified: file.lastModified || Date.now()
            };

            // Add flightStatFileOtherId for multiple file uploads
            if (multiple) {
              newFile.flightStatFileOtherId = uploadedFile.id;
            }

            // Use functional setState to avoid race conditions with multiple uploads
            this.setState(prevState => {
              const updatedList = [...prevState.fileList, newFile];
              console.log('Adding file to list:', {
                fileName: newFile.name,
                previousLength: prevState.fileList.length,
                newLength: updatedList.length
              });
              return {
                fileList: updatedList,
                isLoading: false
              };
            });

            message.success(`Upload ${file.name} success`);

            // Notify parent component if callback provided
            if (this.props.onUploadSuccess) {
              this.props.onUploadSuccess(newFile, data);
            }
          } else if (data.isDuplicate) {
            message.warning(data.uploadMsg || "File already exists");
            this.setState({ isLoading: false });
          } else {
            message.error("Upload failed - no file data returned");
            this.setState({ isLoading: false });
          }
        } else {
          message.error("Upload failed");
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        console.error("Upload error:", error);
        message.error("Upload failed");
        this.setState({ isLoading: false });
      });
  };

  formatBytes = (bytes, decimals) => {
    if (bytes === 0) return "0 Bytes";
    var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  onDelete = (file) => {
    const { type, multiple, id } = this.props;
    let { fileList } = this.state;
    const _id = multiple ? file.flightStatFileOtherId : id;
    const body = { typeFile: type, deleteId: _id };

    this.props.deleteFile(body).then((res) => {
      if (res && res.payload && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
        message.success("Delete " + file.name + " success");
        const updatedFileList = fileList.filter(
          (x) => multiple
            ? x.flightStatFileOtherId !== file.flightStatFileOtherId
            : x.uid !== file.uid
        );
        this.setState({ fileList: updatedFileList });

        // Notify parent component if callback provided
        if (this.props.onDeleteSuccess) {
          this.props.onDeleteSuccess(file);
        }
      } else {
        message.error("Ops! Delete failed");
      }
    });
  };

  render () {
    const { isNoDownload, accept, multiple } = this.props;
    const { fileList, isLoading } = this.state;
    let defaultAccept = ".doc,.docx,.pdf,.xlsx,.xls";

    if (accept) defaultAccept = accept;

    return (
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div className="input-group">
          <div className="input-group-prepend mb-2">
            <Upload
              accept={defaultAccept}
              showUploadList={false}
              style={{ width: "100%" }}
              beforeUpload={() => false}
              onChange={this.handleUpload}
              multiple={multiple}
              disabled={isLoading}
            >
              <Button block className="btn-success" loading={isLoading}>
                <Icon type="plus" className="align-middle" />
                <span className="align-top">
                  {isLoading ? "Uploading..." : "Add File"}
                </span>
              </Button>
            </Upload>
            {!isNoDownload && (
              <Button block className="btn-primary ml-1">
                <Icon type="cloud-download" className="align-middle" />
                <span className="align-top">Download Form</span>
              </Button>
            )}
          </div>
        </div>

        {fileList.map((f, i) => (
          <div
            key={f.uid || i}
            className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-inline px-0 mb-1"
          >
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-sm-12 col-12 px-0">
              <FontAwesomeIcon icon="file" className="text-success" />
              <span className="ml-2">{f.name}</span>
            </div>
            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-6">
              {f.size && this.formatBytes(f.size)}
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-5 col-6">
              {f.lastModified ? moment(f.lastModified).format("DD MMM YYYY") : "-"}
            </div>
            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-12 text-right">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-success btn-sm mr-2 text-success"
                href={f.url}
              >
                <FontAwesomeIcon icon="download" />
              </a>
              <Popover
                placement="bottomLeft"
                content={
                  <button
                    onClick={() => this.onDelete(f)}
                    className="btn btn-outline-danger btn-sm"
                  >
                    Delete
                  </button>
                }
                trigger="click"
              >
                <button className="btn btn-outline-danger btn-sm">
                  <FontAwesomeIcon icon="trash" />
                </button>
              </Popover>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.language,
});

const mapDispatchToProps = (dispatch) => ({
  uploadFile: (param) => dispatch(uploadFile(param)),
  deleteFile: (body) => dispatch(deleteFile(body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadFile);
